import React, { useState, useEffect } from 'react';
import { Divider } from 'primereact/divider';
import VisitsBarChart from './VisitsBarChart';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { privateFetch } from '../../../../utils/apiHelper';

function AnalyticsPage({ isActive }) {
  const { accountContext } = useAccountContext();
  const [dataUser, setDataUser] = useState({});
  const [dataVisits, setDataVisits] = useState({});

  const fetchDataUser = async () => {
    await privateFetch('GET', 'analytics', `/cu/${accountContext.id}/total_user/`).then((res) => {
      setDataUser(res);
    });
  };

  const fetchDataVisits = async () => {
    await privateFetch('GET', 'analytics', `/cu/${accountContext.id}/total_visits/`).then((res) => {
      setDataVisits(res);
    });
  };

  useEffect(() => {
    fetchDataUser();
    fetchDataVisits();
    // eslint-disable-next-line
  }, []);

  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper label="Mesure d'audience">
        <VisitsBarChart
          data={dataUser}
          title={"Nombre d'utilisateurs uniques par site sur les 12 derniers mois"}
        />
        <Divider />
        <VisitsBarChart
          data={dataVisits}
          title={'Nombre de session par site sur les 12 derniers mois'}
          message={'Le calcul des sessions a été implémenté le 6 octobre 2025'}
        />
      </PageWrapper>
    </div>
  );
}

export default AnalyticsPage;
